export default "__VITE_ASSET__CA9nEIvD__"